<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <h1 class="ob-page-title mb-4">Assignments</h1>
      <section>
        <div class="d-flex justify-content-between flex-column flex-md-row obrame-action-row">
          <div class="p-2 order-2 order-md-0">
            <div class="d-flex btn-group me-2">
              <button type="button" class="btn btn-obrame-secondary">
                <fa-icon [icon]="faList" [fixedWidth]="true" class="fixed"></fa-icon> Grid View
              </button>
              <!-- <button type="button" class="btn btn-obrame-secondary">
                <fa-icon [icon]="faCalendarDays" [fixedWidth]="true" class="fixed"></fa-icon> Calendar
              </button> -->
            </div>
          </div>
          <div class="me-auto p-2 order-1">
            <app-assignment-filters [model]="filter"
            (filterSelectedEvent)="onApplyFilter($event)"></app-assignment-filters>
          </div>
          <div class="p-2 order-0 order-md-2">
            <a class="btn btn-obrame-primary" [routerLink]='["/assignments/assignment"]'>
              <fa-icon [icon]="faClipboardList" class="px-2"></fa-icon>
              New Assignment
            </a>
          </div>
        </div>
      </section>
      <section class="pt-4">
        @if (assignmentsModel) {
          <div class="row row-cols-1 row-cols-md-3 g-4">
            @for (model of assignmentsModel; track model) {
              <div class="col">
                <a [routerLink]='["../assignment", model.id]' class="text-decoration-none">
                  <div class="card obrame-card h-100">
                    <div class="card-body">
                      <h5 class="ob-card-title mb-4">{{model.propertyAddress}}</h5>
                      <div class="ob-card-detail-row">
                        <div class="ob-card-icon ob-card-icon--primary">
                          <fa-icon [icon]="faUser" [fixedWidth]="true"></fa-icon>
                        </div>
                        <div class="ob-card-detail-text">
                          <span class="ob-card-detail-label">Team</span>
                          <span class="ob-card-detail-value">{{model.teamName}}</span>
                        </div>
                      </div>
                      <div class="ob-card-detail-row">
                        <div class="ob-card-icon ob-card-icon--info">
                          <fa-icon [icon]="faCalendar" [fixedWidth]="true"></fa-icon>
                        </div>
                        <div class="ob-card-detail-text">
                          <span class="ob-card-detail-label">Date</span>
                          <span class="ob-card-detail-value">{{model.assignmentDate}}</span>
                        </div>
                      </div>
                      <div class="ob-card-detail-row">
                        <div class="ob-card-icon ob-card-icon--warning">
                          <fa-icon [icon]="faClock" [fixedWidth]="true"></fa-icon>
                        </div>
                        <div class="ob-card-detail-text">
                          <span class="ob-card-detail-label">Time</span>
                          <span class="ob-card-detail-value">{{model.startTime}} ({{model.duration}} h)</span>
                        </div>
                      </div>
                      <div class="ob-card-detail-row">
                        <div class="ob-card-icon ob-card-icon--neutral">
                          <fa-icon [icon]="faHourglassHalf" [fixedWidth]="true"></fa-icon>
                        </div>
                        <div class="ob-card-detail-text">
                          <span class="ob-card-detail-label">Status</span>
                          <span class="ob-card-detail-value">{{model.status}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <small>Last updated {{model.updatedOn}}</small>
                    </div>
                  </div>
                </a>
              </div>
            }
          </div>
        }
      </section>
    </div>
  </div>
</div>